export const LONG_FORM_DRAFT_STATUS = {
  draft: 'long_form_draft',
  generating: 'long_form_generating',
  editing: 'long_form_editing',
  archived: 'long_form_archived',
} as const;
export type LongFormDraftStatus =
  (typeof LONG_FORM_DRAFT_STATUS)[keyof typeof LONG_FORM_DRAFT_STATUS];

export const LONG_FORM_DRAFT_STATUS_FLAG = {
  creatingCompliantDraft: 'creatingCompliantDraft',
  applyingCompliance: 'applyingCompliance',
  retryingCompliance: 'retryingCompliance',
} as const;
export type LongFormDraftStatusFlag =
  (typeof LONG_FORM_DRAFT_STATUS_FLAG)[keyof typeof LONG_FORM_DRAFT_STATUS_FLAG];

export const LONG_FORM_CONTINUE_MODE = {
  fromEmpty: 'from_empty',
  continue: 'continue',
  insertion: 'insertion',
} as const;
export type LongFormContinueMode =
  (typeof LONG_FORM_CONTINUE_MODE)[keyof typeof LONG_FORM_CONTINUE_MODE];

export const prepareContinueModeForBackend = (
  mode: LongFormContinueMode
): LongFormContinueMode | undefined => {
  // `fromEmpty` is FE-only value, so we should not send it to the backend
  if (mode === LONG_FORM_CONTINUE_MODE.fromEmpty) {
    return undefined;
  }

  return mode;
};

export const LONG_FORM_ORIGINAL_DRAFT_INDEX = '0';
